import type { Pro20User } from '@/features/auth/types/auth.types';

/** Resolves the active branch code from a PRO20 sign-in response */
export function resolveBranchCode(user: Pro20User): string | null {
  if (user.branchCode) {
    return user.branchCode;
  }

  const authorized = user.branches?.find((branch) => branch.authorized);
  if (authorized) {
    return authorized.branchCode;
  }

  return user.branches?.[0]?.branchCode ?? null;
}
